export class ListSelectable {
  id: number = 0;
  checked: boolean = false;

  costructor() {}
}
